import React from 'react';
import PropTypes from 'prop-types';
import { decodeString } from 'lib/stringUtils';
import * as CustomPropTypes from 'lib/CustomPropTypes';
import loadScript from 'lib/loadScript';

import styles from '../styles.module.scss';

// dont think that this is working properly. need to compare
// with uat. for now it is rendering markup
export default class TweetEmbed extends React.Component {
  static propTypes = {
    html: PropTypes.string,
    widget: CustomPropTypes.widget.isRequired,
  };

  static defaultProps = {
    html: null,
  }

  componentDidMount() {
    loadScript('//platform.twitter.com/widgets.js', { attributes: { defer: true, charset: 'utf-8' } })
      // re-running `.process` here since in SPA mode, the script needs to re-parse
      // embeds on the page when navigating to a new article
      .then(() => {
        window.twttr.widgets.load(this.embed);
      });
  }

  render() {
    const { html, widget } = this.props;

    // TODO move script-strip to class all other widgets can extend.
    // Strip script tags from content.
    const markup = (html || decodeString(widget.baseline))
      .replace(/<script[^<]+src="([^"]+)"[^<]*><\/script>/gi, '');

    /* eslint-disable react/no-danger */
    return (
      <div
        ref={(el) => { this.embed = el; }}
        className={styles.usePresentation}
        dangerouslySetInnerHTML={{ __html: markup }}
      />
    );
    /* eslint-enable react/no-danger */
  }
}
